import React from "react";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./socialButtons.css";
import SocialIcon from "../SocialIcon";
import apple from "@Assets/images/login/apple.png";
import google from "@Assets/images/login/google.svg";
import facebook from "@Assets/images/login/facebook.svg";
var Button = props => {
  var {
    label,
    type,
    url,
    handleLogin,
    onClick
  } = props;
  var classes = mergeClasses(defaultClasses, props.classes);
  var style = {
    "--amslBtnBg": "var(--amsl-".concat(type, "-button__background)"),
    "padding": "0px"
  };
  var icons = {
    apple,
    google,
    facebook
  };
  return /*#__PURE__*/React.createElement("button", {
    style: style,
    type: "button",
    title: "Sign in with ".concat(label),
    className: "".concat(classes.button),
    onClick: () => {
      handleLogin({
        type,
        url
      });
      if (onClick) onClick();
    }
  }, /*#__PURE__*/React.createElement(SocialIcon, {
    type: type,
    icon: icons[type]
  }));
};
export default Button;